// AUPRÉA — Étape 15 : analyse question par question (admin)
import { useEffect, useMemo, useState } from "react";
import { C, Select, Spinner } from "./shared";
import { getB, Card, Barre, pctTxt, qIndex, optLabel, TYPES, th, td } from "./bilansShared";

const LEGENDES = { bilan_succession: ["Oui", "Partiellement", "Non"], bilan_dirigeants: ["Favorable", "Intermédiaire", "Défavorable"], foncier_clair: ["Favorable", "Je ne sais pas", "Défavorable"], ouvrir_succession: ["Favorable", "Intermédiaire", "Défavorable"] };

const Ligne = ({ q, meta, leg }) => (
  <tr data-testid={`q-row-${q.code}`}>
    <td style={{ ...td, maxWidth: 420 }}>
      <div style={{ color: C.navy }}>{meta?.texte || q.libelle || q.code}</div>
      <div style={{ fontSize: 10.5, color: C.muted }}>{q.code}{(meta?.section || q.section) ? ` · ${meta?.section || q.section}` : ""}{q.confidentiel ? " · confidentielle" : ""}</div>
    </td>
    <td style={td} data-testid={`q-n-${q.code}`}>{q.n}</td>
    {q.kind === "gradue" ? (<>
      <td style={td}><Barre parts={[[q.pct_fav, C.teal], [q.pct_inter, C.gold], [q.pct_defav, C.red]]} /></td>
      <td style={{ ...td, color: C.teal }} data-testid={`q-fav-${q.code}`}>{pctTxt(q.pct_fav)}</td>
      <td style={{ ...td, color: C.golddm }} data-testid={`q-inter-${q.code}`}>{pctTxt(q.pct_inter)}</td>
      <td style={{ ...td, color: C.red, fontWeight: 700 }} data-testid={`q-defav-${q.code}`}>{pctTxt(q.pct_defav)}</td>
    </>) : (<>
      <td style={td}><Barre parts={[[q.pct_oui, C.purp]]} /></td>
      <td style={{ ...td, color: C.purp, fontWeight: 700 }} colSpan={3} data-testid={`q-oui-${q.code}`}>
        {q.ind ? `${pctTxt(q.pct_oui)} de « Oui » (indicateur)` : q.top.map(([v, n]) => `${optLabel(meta, v)} : ${n}`).join(" · ")}
      </td>
    </>)}
  </tr>
);

export const BilansReponses = ({ f }) => {
  const [d, setD] = useState(null);
  const [type, setType] = useState(f.type || "bilan_succession");
  const [tri, setTri] = useState("defav");
  useEffect(() => { setD(null); getB("/admin/bilans-kpi/reponses", f).then(setD); }, [f]);
  useEffect(() => { if (f.type) setType(f.type); }, [f.type]);
  const idx = useMemo(() => qIndex(type), [type]);
  if (!d) return <Spinner />;
  const bloc = d[type] || { questions: [], n_bilans: 0 };
  const key = (q) => tri === "defav" ? -(q.kind === "gradue" ? q.pct_defav : q.pct_oui) : tri === "n" ? -q.n : q.code;
  const qs = [...bloc.questions].sort((a, b) => (key(a) > key(b) ? 1 : key(a) < key(b) ? -1 : 0));
  const grad = qs.filter(q => q.kind === "gradue"), ind = qs.filter(q => q.kind !== "gradue");
  const leg = LEGENDES[type];
  const head = (cols) => <thead><tr>{cols.map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>;
  return (
    <div data-testid="bilans-reponses" style={{ display: "grid", gap: 14 }}>
      <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
        <div style={{ width: 230 }}><Select value={type} onChange={e => setType(e.target.value)} data-testid="reponses-type">{Object.entries(TYPES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</Select></div>
        <div style={{ width: 260 }}><Select value={tri} onChange={e => setTri(e.target.value)} data-testid="reponses-tri">
          <option value="defav">Trier : % de réponses défavorables</option><option value="code">Trier : ordre du questionnaire</option><option value="n">Trier : nombre de réponses</option>
        </Select></div>
        <span style={{ fontSize: 12, color: C.mid }} data-testid="reponses-nb-bilans">{bloc.n_bilans} bilan(s) · croisez avec les filtres d'âge et de territoire ci-dessus</span>
      </div>
      <Card title={`Questions · ${leg.join(" / ")}`} testid="reponses-gradue" style={{ overflowX: "auto" }}>
        {grad.length ? <table style={{ width: "100%", fontSize: 12, borderCollapse: "collapse" }}>{head(["Question", "Réponses", "Répartition", leg[0], leg[1], leg[2]])}
          <tbody>{grad.map(q => <Ligne key={q.code} q={q} meta={idx[q.code]} leg={leg} />)}</tbody></table>
          : <div style={{ color: C.muted, fontSize: 12 }}>Aucune réponse sur cette sélection.</div>}
      </Card>
      {ind.length > 0 && <Card title="Indicateurs (questions confidentielles et autres réponses)" testid="reponses-indicateurs" style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", fontSize: 12, borderCollapse: "collapse" }}>{head(["Question", "Réponses", "Part de Oui", "Détail", "", ""])}
          <tbody>{ind.map(q => <Ligne key={q.code} q={q} meta={idx[q.code]} leg={leg} />)}</tbody></table>
      </Card>}
    </div>
  );
};
